import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import ImageLibpixel from "./image-libpixel.js";
import { _ } from "../utils/i18n";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 20px 0;
  align-items: center;
  justifycontent: flex-start;
  width: 100%;
`;
const Card = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin: 10px 0;
  align-items: center;
`;
const CardInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  line-height: initial;
`;
const Avatar = styled(ImageLibpixel)`
  width: 80px;
  height: 80px;
  marginleft: 0;
  border-radius: 140px;
  object-fit: cover;
  @media (max-width: 770px) {
    margin-left: 5px;
  }
`;
const Name = styled.h4`
  width: 167px;
  margin-top: 10px;
  margin-bottom: 0;
  margin-left: 30px;
  letter-spacing: 1px;
  font-size: 1.2rem;
  @media (max-width: 770px) {
    margin-left: 20;
  }
`;
const JobTitle = styled.p`
  width: 167px;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 30px;
  font-size: 0.9rem;
  font-family: Poppins; sans-serif;
  @media (max-width: 770px) {
    margin-left: 20px;
  };
`;
const InfoContainer = styled.div`
  display: inherit;
  flex-direction: column;
  margin-left: 30px;
  margin-bottom: 0;
  @media (max-width: 770px) {
    margin-left: 20px;
  }
`;
const InfoData = styled.a`
  padding-right: 30px;
  fontSize: 0.9rem;
  margin-bottom: 0;
  text-decoration: none;
  font-family: Poppins; sans-serif;
  color: #000 !important;
  &:hover {
    text-decoration: underline;
  }
  &:last-child {
    padding-right: 0;
  }
  @media (max-width: 770px) {
    paddingRight: 20;
  }
`;
const Tag = styled.div`
  width: 40%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;
const TagBox = styled.div`
  padding: 6px 10px;
  border: 0.2px solid #bdbdbd; /*theme.shape.borderThin*/
  color: #000;
  font-family: Poppins; sans-serif;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  margin: 5px;
`;
const TagLabel = styled.p`
  margin: 0;
`;

const ContactCard = ({
  hasTags,
  imgAlt,
  remoteImg,
  name,
  jobTitle,
  number,
  email,
}) => {
  const fullWidth = {
    width: "100%",
  };
  const halfWidth = {
    width: "60%",
  };
  const widthSize = hasTags === true ? halfWidth : fullWidth;
  const hasTag =
    hasTags === true ? (
      <Tag>
        <TagBox>
          <TagLabel>{_("Grafisk Design")}</TagLabel>
        </TagBox>
        <TagBox>
          <TagLabel>{_("Rådgivning")}</TagLabel>
        </TagBox>
        <TagBox>
          <TagLabel>{_("SEO")}</TagLabel>
        </TagBox>
        <TagBox>
          <TagLabel>{_("Google")}</TagLabel>
        </TagBox>
        <TagBox>
          <TagLabel>{_("Programmering")}</TagLabel>
        </TagBox>
      </Tag>
    ) : null;

  return (
    <Wrapper>
      <Card itemScope itemType="http://schema.org/Person" style={widthSize}>
        <Avatar itemProp="image" src={remoteImg} alt={imgAlt} />
        <CardInnerContainer>
          <Name itemProp="name">{name}</Name>
          <JobTitle itemProp="jobTitle">{jobTitle}</JobTitle>
          <InfoContainer>
            {number && number !== null && number !== "null" && (
              <InfoData
                itemProp="telephone"
                href={`tel:${
                  number && number.replace(/ /g, "").replace("+", "00")
                }`}
              >
                {number}
              </InfoData>
            )}
            {email && email !== null && email !== "null" && (
              <InfoData itemProp="email" href={`mailto: ${email}`}>
                {email && email}
              </InfoData>
            )}
          </InfoContainer>
        </CardInnerContainer>
      </Card>
      {hasTag}
    </Wrapper>
  );
};

ContactCard.propTypes = {
  remoteImg: PropTypes.string,
  imgAlt: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  number: PropTypes.string.isRequired,
  jobTitle: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  hasTags: PropTypes.bool,
};

ContactCard.defaultProps = {
  remoteImg: "",
  imgAlt: "Employee",
  hasTags: false,
};

export default ContactCard;
